import { isIEditorV3 } from "@azu-business/editor-v3";
import { isObjectRecord } from "aic";
import { CommentReadDto } from "./interface";

/**
 * Type guard to validate an object is a CommentReadDto.
 *
 * @param obj - Object to check
 * @returns True if the object matches CommentReadDto
 */
export const isCommentReadDto = (obj: unknown): obj is CommentReadDto => {
  if (!isObjectRecord(obj)) return false;

  return (
    // Check properties types
    typeof obj.id === "string" &&
    typeof obj.authorId === "number" &&
    isIEditorV3(obj.content) &&
    typeof obj.authorDisplayName === "string" &&
    (obj.parentId === undefined || typeof obj.parentId === "string") &&
    (obj.relatedTo === undefined || typeof obj.relatedTo === "string") &&
    typeof obj.createdAt === "string" &&
    typeof obj.updatedAt === "string" &&
    typeof obj.updateCount === "number" &&
    (obj.entityVersion === undefined || typeof obj.entityVersion === "string")
  );
};
